module.exports = "<div class=\"status-indicator\" [class]=\"'status-indicator ' + statusIndicatorColor\"></div>\n"


//////////////////
// WEBPACK FOOTER
// /app/src/app/shared/components/status-indicator/status-indicator.component.html
// module id = ../../../../../src/app/shared/components/status-indicator/status-indicator.component.html
// module chunks = 12